import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Autocomplete,
  TextField,
  Button,
  Typography,
  Box,
} from '@mui/material';
import './FormulaEditor.css';

const FormulaEditor = () => {
  const [headings, setHeadings] = useState([]);
  const [selectedHeading, setSelectedHeading] = useState(null);
  const [formulas, setFormulas] = useState([]);

  // Fetch Headings
  useEffect(() => {
    axios.get('https://ideatorportal.in/api/get_headings.php')
      .then((res) => setHeadings(res.data))
      .catch((err) => console.error('Error fetching headings:', err));
  }, []);

  // Fetch Formulas for selected heading
  useEffect(() => {
    if (!selectedHeading?.id) return;

    axios.get('https://ideatorportal.in/api/get_formulas.php')
      .then((res) => {
        const filtered = res.data.filter(f => f.heading_id === selectedHeading.id);
        setFormulas(filtered);
      })
      .catch((err) => console.error("Error fetching formulas:", err));
  }, [selectedHeading]);

  // Handle input change
  const handleChange = (id, field, value) => {
    setFormulas(prev =>
      prev.map(f => (f.id === id ? { ...f, [field]: value } : f))
    );
  };

  // Save formula changes
  const handleSave = async (formula) => {
    try {
      const res = await axios.post('https://ideatorportal.in/api/update_formula.php', {
        id: formula.id,
        material_quantity: parseFloat(formula.material_quantity),
        base_quantity: parseFloat(formula.base_quantity)
      });

      if (res.data.success) {
        alert('✅ Formula updated!');
      } else {
        alert('❌ Update failed.');
      }
    } catch (err) {
      alert('❌ API error occurred.');
    }
  };

  // Delete formula
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this formula?")) return;

    try {
      const res = await axios.post('https://ideatorportal.in/api/delete_formula.php', {
        id
      });

      if (res.data.success) {
        setFormulas(prev => prev.filter(f => f.id !== id));
        alert('🗑️ Formula deleted.');
      } else {
        alert('❌ Delete failed.');
      }
    } catch (err) {
      alert('❌ API error occurred.');
    }
  };

  return (
    <div className="formula-container">
      <h2 className="formula-title"> Formula Editor</h2>

      {/* Autocomplete Dropdown */}
      <div className="heading-select">
        <label>Select Work Heading:</label>
        <Autocomplete
          options={headings}
          getOptionLabel={(option) => `${option.name} (${option.unit})`}
          value={selectedHeading}
          onChange={(event, newValue) => setSelectedHeading(newValue)}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => <TextField {...params} label="Choose Heading" className="input-field" />}
        />
      </div>

      {/* Formulas */}
      {selectedHeading ? (
        <div className="space-y-6">
          {formulas.map((f) => (
            <div key={f.id} className="formula-card">
              <h3 className="material-name">{f.material_name}</h3>

              <div className="input-group">
                <div>
                  <label>Material Quantity ({f.material_unit})</label>
                  <input
                    type="number"
                    value={f.material_quantity}
                    onChange={(e) => handleChange(f.id, 'material_quantity', e.target.value)}
                  />
                </div>

                <div>
                  <label>Base Quantity ({f.heading_unit})</label>
                  <input
                    type="number"
                    value={f.base_quantity}
                    onChange={(e) => handleChange(f.id, 'base_quantity', e.target.value)}
                  />
                </div>
              </div>

              <div className="unit-ratio">
                <strong>Unit Ratio:</strong> {f.material_unit} / {f.heading_unit}
              </div>

              <div className="button-group">
                <Button className="button-save" onClick={() => handleSave(f)} variant="contained">
                  💾 Save Formula
                </Button>
                <Button className="button-delete" onClick={() => handleDelete(f.id)} color="error" variant="outlined">
                  🗑️ Delete Formula
                </Button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="placeholder-text">
          Please select a heading to view and edit formulas.
        </div>
      )}
    </div>
  );
};

export default FormulaEditor;
